import { AxiosError } from "axios";
import client from "./client";

export type UpdateMiscEmployeeTaskAccountBody = {
  miscEmployeeTaskID: number;
  accountCodeID?: number;
  miscDescription?: string;
};

export function getUpdateMiscEmployeeTaskErrorMessage(error: unknown): string {
  if (error && typeof error === "object" && "response" in error) {
    const ax = error as AxiosError<{ message?: string }>;
    const msg = ax.response?.data?.message;
    if (typeof msg === "string" && msg.length > 0) {
      return msg;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Error updating misc employee task";
}

export async function updateMiscEmployeeTaskAccountCodeAndDescription(
  body: UpdateMiscEmployeeTaskAccountBody
): Promise<{ success: boolean }> {
  const response = await client.post<{ success: boolean }>(
    "/admin/miscEmployeeTask/updateAccountCodeAndDescription",
    body
  );
  return response.data;
}
